export const ENGLISH_TRANSLATIONS = {
  hellovue: {
    frontpage: "Frontpage",
    site: {
      name: "Liferay Hello Vue",
    },
    dropdown: {
      select_language: 'Select language',
      change_type: 'Vaihda talotyyppi EN'
    },
    sidenav: {
      close: 'Close Navigation',
      change_view: "change View",
      street_view: "Street View",
      cut_view: "Cross Section View",
    },
    view: {
      street_view: 'street_view',
      cross_section_view: 'cross_section_view'
    },
    pov_of_educational_buildings: "Oppimisen tilojen poikkileikkausnäkymät",
    buildings: "Rakennukset",
    maincontent: {
      back_to_frontpage: "Takaisin oppimisen rakennuksiin",
      back_to_buildings: "Takaisin rakennuksiin",
      move_to_cross_section_view: "Siirry poikkileikkausnäkymään"
    },
    header:{
      street_view_of_learning_facilities: "Oppilaitosten katunäkymä"
    }
  },
};
